export default __webpack_public_path__ + "static/google-cb42f530c8462f798ddd060b071dd8c4.png";